import _Icon from './svg-sprite.js';
import '../_chunks/dep-6108ca17.js';
import 'vue';
import './props/props.js';
import '../utils/config-context.js';
import '../utils/use-size-props.js';
import '../utils/use-common-classname.js';
import '../utils/check-url-and-load.js';
import '../style/css.js';

var Icon = _Icon;

export default Icon;
export { Icon };
//# sourceMappingURL=index.js.map
